import type { PropsWithChildren } from "react";

import { twJoin } from "tailwind-merge";

export function Badge({ children, attention }: PropsWithChildren<{ attention?: "danger" | "warning" }>) {
  return (
    <div
      className={twJoin(
        "inline-block shrink-0 rounded-full border px-2 py-0.5 font-hint",
        attention === "danger" && "border-danger bg-danger/20 text-danger",
        attention === "warning" && "border-attention bg-attention/20 text-attention",
        attention === undefined && "border-grass bg-grass/20 text-turtle",
      )}
    >
      {children}
    </div>
  );
}
